import { render, staticRenderFns } from "./FreeTimeForeign.vue?vue&type=template&id=ec4050f8&"
import script from "./FreeTimeForeign.vue?vue&type=script&lang=js&"
export * from "./FreeTimeForeign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports